module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "toc-title",
    staticStyle: {
      "margin-top": "6em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _c('td', [_c('p', {
    staticStyle: {
      "margin-bottom": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/09_introduction#intro",
      "id": "toc-intro"
    }
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "center",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/10_part_1#pt1",
      "id": "toc-pt1"
    }
  }, [_c('em', [_vm._v("Part One")]), _c('br'), _vm._v("APPRENTICESHIP")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": ".8em"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/11_chapter_1#ch1"
    }
  }, [_vm._v("I")])]), _c('td', [_c('a', {
    attrs: {
      "href": "#/text/11_chapter_1#ch1"
    }
  }, [_vm._v("MY FIRST DIVE")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/12_chapter_2#ch2"
    }
  }, [_vm._v("II")])]), _c('td', [_c('a', {
    attrs: {
      "href": "#/text/12_chapter_2#ch2"
    }
  }, [_vm._v("MY FIRST PATROL")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/13_chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DISASTER")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/14_chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“THE BAY” AND NORTH RUSSIA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/15_chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIRST LIEUTENANT")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEDITERRANEAN")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RECALLED HOME")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“PERISHER”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MY FIRST COMMAND")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "center",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1em",
      "font-size": "1.1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_part_2#pt2",
      "id": "toc-pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Part Two")]), _c('br'), _vm._v("H.M. SUBMARINE “STORM”")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BUILDING")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRIALS AND WORKING-UP")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSIDE THE ARCTIC CIRCLE")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/24_chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PASSAGE TO CEYLON")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN THE NARROWS: MALACCA STRAITS")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BETWEEN PATROLS: CEYLON")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/27_chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/27_chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANDAMAN ISLANDS")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/28_chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLOAK AND DAGGER")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/29_chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII")])]), _c('td', [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/29_chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DESTINATION PENANG")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/30_chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/30_chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MERGUI ARCHIPELAGO")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/31_chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/31_chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GUN ATTACK ON CONVOY")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "id": "toc-ch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/32_chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/text/32_chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THROUGH THE LOMBOK STRAIT")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/33_epilogue#epi",
      "id": "toc-epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticStyle: {
      "margin-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/34_ships_company#com",
      "id": "toc-com",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SHIP’S COMPANY")])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f65101","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/08_contents.vue
// module id = 75
// module chunks = 0